import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { pdfjs } from '@carboledger/ui';
import { App } from './App';

// App-global styles imported ONCE here; per-component styles are co-located (ARCHITECTURE §5).
import '@/styles/globals.scss';

// The LEGACY worker, matching the engine @carboledger/ui bundles — see its PDFViewer/CLAUDE.md.
import pdfWorkerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url';
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
